(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[228],{

/***/ 478:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms",
      function () {
        return __webpack_require__(1154);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/seo-config.js
var SITE_CONFIG = {
    name: "Evry Health",
    url: "https://www.evryhealth.com",
    defaultOgImage: "https://www.evryhealth.com/og-image.png",
    twitterCard: "summary_large_image"
};
var PAGE_SEO = {
    "": {
        title: "Evry Health | Modern Health Insurance for Texas Employers & Members",
        description: "Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.",
        ogDescription: "Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.",
        twitterTitle: "Evry Health",
        twitterDescription: "Modern health insurance for Texas employers and members."
    },
    "admission-notification": {
        title: "Inpatient Admission Notification | Evry Health",
        description: "How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.",
        ogDescription: "How to submit inpatient admission notifications to Evry Health.",
        twitterTitle: "Admission Notification | Evry Health",
        twitterDescription: "Submit inpatient admission notifications to Evry Health."
    },
    careers: {
        title: "Careers at Evry Health | Join Our Team",
        description: "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
        twitterTitle: "Careers at Evry Health",
        twitterDescription: "Explore open roles at Evry Health in Dallas, Texas."
    },
    "community-resources": {
        title: "Texas Community Resources for Members | Evry Health",
        description: "A curated list of local community, health, food, and legal resources across Texas for Evry Health members.",
        twitterTitle: "Texas Community Resources | Evry Health",
        twitterDescription: "Community, health, food, and legal resources for Evry Health members in Texas."
    },
    "contact-us": {
        title: "Contact Evry Health | Get a Quote",
        description: "Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.",
        ogDescription: "Get in touch with Evry Health for plan quotes, member support, or general questions.",
        twitterTitle: "Contact Evry Health",
        twitterDescription: "Get a quote or ask us anything. Call 1-855-579-3879."
    },
    faqs: {
        title: "Frequently Asked Questions | Evry Health",
        description: "Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.",
        twitterDescription: "Answers to common questions about Evry Health plans and coverage."
    },
    forms: {
        title: "Forms & Notices | Evry Health",
        description: "Download member and provider forms, notices, and resources from Evry Health.",
        twitterDescription: "Download forms and notices from Evry Health."
    },
    fwa: {
        title: "Report Fraud, Waste & Abuse | Evry Health",
        description: "How Evry Health members and providers can report suspected fraud, waste, or abuse.",
        twitterDescription: "Report suspected fraud, waste, or abuse to Evry Health."
    },
    "how-we-compare": {
        title: "How Evry Health Compares | Plan Comparison",
        description: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.",
        ogDescription: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.",
        twitterTitle: "How Evry Health Compares",
        twitterDescription: "Compare Evry Health plans against traditional carriers."
    },
    "how-we-do-it": {
        title: "How Evry Health Works | Built for Modern Workforces",
        description: "Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.",
        twitterTitle: "How Evry Health Works",
        twitterDescription: "Built for the modern business and the mobile workforce."
    },
    "join-the-evry-network": {
        title: "Join the Evry Health Provider Network",
        description: "Apply to join the Evry Health provider network. Faster payments. Transparent terms.",
        twitterTitle: "Join the Evry Health Network",
        twitterDescription: "Apply to join the Evry Health provider network."
    },
    login: {
        title: "Sign In | Evry Health",
        description: "Sign in to the Evry Health member portal.",
        noindex: true
    },
    "meet-your-new-team": {
        title: "Meet Your Evry Health Care Team",
        description: "Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.",
        ogDescription: "Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.",
        twitterDescription: "A dedicated team of nurses, nutritionists, and doctors — included at no extra cost."
    },
    members: {
        title: "Member Registration | Evry Health",
        description: "Register for your Evry Health member portal account.",
        noindex: true
    },
    mobileapp: {
        title: "Evry Health Mobile App | Manage Your Plan On the Go",
        description: "Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.",
        ogDescription: "Download the Evry Health mobile app to view your ID card, find providers, and message your care team.",
        twitterTitle: "Evry Health Mobile App",
        twitterDescription: "Manage your health plan on the go with the Evry Health app."
    },
    news: {
        title: "News & Press | Evry Health",
        description: "The latest news, press releases, and announcements from Evry Health.",
        twitterDescription: "The latest news and announcements from Evry Health."
    },
    "non-discrimination-policy": {
        title: "Non-Discrimination Policy | Evry Health",
        description: "Evry Health's commitment to non-discrimination and language assistance for members.",
        twitterDescription: "Non-discrimination and language assistance for all members."
    },
    "our-story": {
        title: "Our Story | Evry Health",
        description: "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
        ogDescription: "We're on a mission to build the health insurance company we've always wanted for ourselves.",
        twitterDescription: "Building the health insurance company we've always wanted."
    },
    partners: {
        title: "Partners | Evry Health",
        description: "The partners and providers Evry Health works with to deliver modern health insurance.",
        twitterDescription: "Partners and providers delivering modern health insurance."
    },
    "prior-auth-list-updates": {
        title: "Prior Authorization List Updates | Evry Health",
        description: "Recent updates to the Evry Health prior authorization list for providers.",
        twitterDescription: "Recent updates to the prior authorization list for providers."
    },
    "prior-auth-tool": {
        title: "Prior Authorization Tool | Evry Health for Providers",
        description: "Look up whether a procedure requires prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization Tool | Evry Health",
        twitterDescription: "Check if prior authorization is required for a procedure."
    },
    "prior-authorization": {
        title: "Prior Authorization | Evry Health for Providers",
        description: "Information for providers on which procedures require prior authorization with Evry Health.",
        ogDescription: "Provider resources for prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization | Evry Health",
        twitterDescription: "Provider resources for prior authorization with Evry Health."
    },
    "privacy-policy": {
        title: "Privacy Policy | Evry Health",
        description: "How Evry Health collects, uses, and protects your personal and health information.",
        twitterDescription: "How Evry Health protects your personal and health information."
    },
    providerdirectory: {
        title: "Provider Directory | Evry Health",
        description: "Find in-network providers with the Evry Health provider directory.",
        noindex: true
    },
    "request-to-join": {
        title: "Request to Join | Evry Health Network",
        description: "Submit a request to join the Evry Health provider network. Simple application process.",
        ogDescription: "Submit a request to join the Evry Health provider network.",
        twitterTitle: "Request to Join | Evry Health",
        twitterDescription: "Join the Evry Health provider network."
    },
    "retrospective-reviews": {
        title: "Retrospective Reviews | Evry Health for Providers",
        description: "Learn how Evry Health determines coverage after treatment has been provided.",
        twitterTitle: "Retrospective Reviews | Evry Health",
        twitterDescription: "How Evry Health determines coverage after treatment."
    },
    rewards: {
        title: "Member Rewards | Evry Health",
        description: "Earn rewards for staying healthy as an Evry Health member.",
        twitterDescription: "Earn rewards for staying healthy with Evry Health."
    },
    terms: {
        title: "Terms of Use | Evry Health",
        description: "Terms of use for the Evry Health website and digital services.",
        twitterDescription: "Terms of use for Evry Health website and services."
    },
    "virtual-care": {
        title: "$0 Virtual Care & Telehealth | Evry Health",
        description: "Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.",
        twitterDescription: "Talk to a board-certified physician 24/7 for $0."
    },
    "why-choose-evry": {
        title: "Why Choose Evry Health | Texas Health Insurance",
        description: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.",
        twitterTitle: "Why Choose Evry Health",
        twitterDescription: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth."
    }
};
function getPageSeo(slug) {
    var page = PAGE_SEO[slug] || {};
    var title = page.title || SITE_CONFIG.name;
    var description = page.description || "";
    var ogTitle = page.ogTitle || title;
    var ogDescription = page.ogDescription || description;
    var ogImage = page.ogImage || SITE_CONFIG.defaultOgImage;
    var twitterTitle = page.twitterTitle || ogTitle;
    var twitterDescription = page.twitterDescription || ogDescription;
    var twitterImage = page.twitterImage || ogImage;
    var noindex = page.noindex || false;
    var url = slug === "" ? "".concat(SITE_CONFIG.url, "/") : "".concat(SITE_CONFIG.url, "/").concat(slug);
    return {
        title: title,
        description: description,
        url: url,
        ogTitle: ogTitle,
        ogDescription: ogDescription,
        ogImage: ogImage,
        twitterTitle: twitterTitle,
        twitterDescription: twitterDescription,
        twitterImage: twitterImage,
        noindex: noindex
    };
}

;// CONCATENATED MODULE: ./components/SEO/SEO.js





var SEO = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = ref.slug, overrides = ref.overrides;
    var router = (0,next_router.useRouter)();
    var resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, "");
    var resolved = getPageSeo(resolvedSlug);
    var seo = overrides ? (0,_object_spread/* default */.Z)({}, resolved, overrides) : resolved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seo.ogTitle
            }, "title"),
            seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,follow"
            }),
            !seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: SITE_CONFIG.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seo.ogDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seo.ogImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: SITE_CONFIG.twitterCard
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: seo.twitterTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: seo.twitterDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: seo.twitterImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);


/***/ }),

/***/ 8148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ BASE_URL; }
/* harmony export */ });
var BASE_URL =  true && window.location.hostname.includes("evryhealth.com") ? "https://api.evryhealth.com/api/v1" : "https://apidev.evryhealth.com/api/v1/";


/***/ }),

/***/ 1154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3976);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9875);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8148);
"use client";








var currentYear = new Date().getFullYear();
var FormsAndPolicies = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), allForms = ref[0], setAllForms = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), currentFormList = ref1[0], setCurrentFormList = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(currentYear), year = ref2[0], setYear = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Members"), category = ref3[0], setCategory = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref5[0], setError = ref5[1];
    var getYears = function(numYears) {
        var currentYear = new Date().getFullYear();
        return Array.from({
            length: numYears
        }, function(_, i) {
            return currentYear - i;
        });
    };
    var years = getYears(3);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([
        [
            "Members",
            "Providers"
        ],
        years
    ]), filters = ref6[0], setFilters = ref6[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var type = router.query.type;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!router.isReady) return;
        fetchAllForms();
        // Set initial category from URL or default to Members
        if (type) {
            setCategory(type);
        } else {
            var defaultCategory = "Members";
            setCategory(defaultCategory);
            // Update URL with default params without page reload
            router.push({
                pathname: router.pathname,
                query: {
                    type: defaultCategory
                }
            }, undefined, {
                shallow: true
            });
        }
    }, [
        router.isReady
    ]);
    // When type changes in URL, update category
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (type) {
            setCategory(type);
        }
    }, [
        type
    ]);
    // Fetch all forms once
    var fetchAllForms = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var res, data, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch("".concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .BASE_URL */ ._, "/Marketing/GetFormFiles"), {
                                method: "POST",
                                body: JSON.stringify({
                                    page: "Forms"
                                }),
                                headers: {
                                    "content-type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        if (!res.ok) {
                            throw new Error(res.statusText);
                        }
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        data = _state.sent();
                        setAllForms(data);
                        setLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        setError(err);
                        setLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchAllForms() {
            return _ref.apply(this, arguments);
        };
    }();
    // Filter forms when category, year, or allForms changes
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        filterForms();
    }, [
        category,
        year,
        allForms
    ]);
    // Client-side filtering function
    var filterForms = function() {
        if (!allForms || allForms.length === 0) return;
        var filtered = allForms.filter(function(form) {
            return form.categories.includes(category) && form.years.includes(parseInt(year));
        }).sort(function(a, b) {
            return a.name.localeCompare(b.name);
        });
        setCurrentFormList(filtered);
    };
    var handleSearch = function() {
        filterForms();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO_SEO__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                className: "object-cover w-full h-full",
                                                src: "filling-documents.png",
                                                alt: "Person filling out documents"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                className: "text-3xl tracking-tight md:text-5xl text-darkBlue",
                                                children: "Forms and Notices"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-1 w-full max-w-screen-xl mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex flex-col items-center justify-center w-full px-4 py-8 rounded-sm shadow-lg bg-white-light sm:px-6 lg:px-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col items-center justify-between w-full gap-14 md:flex-row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col w-full -mt-4 space-y-4 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            htmlFor: "dates",
                                                            className: "ml-4 text-sm font-semibold text-gray-700 font-small",
                                                            children: "Dates"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                            id: "dates",
                                                            name: "dates",
                                                            onChange: function(e) {
                                                                return setYear(e.target.value);
                                                            },
                                                            value: year,
                                                            className: "block w-full px-6 py-3 text-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-green focus:border-green sm:text-sm",
                                                            children: filters[1].map(function(year, index) {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    children: year
                                                                }, index);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex flex-col w-full -mt-4 space-y-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                            htmlFor: "categories",
                                                            className: "ml-4 text-sm font-semibold text-gray-700",
                                                            children: "Categories"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                            id: "categories",
                                                            name: "categories",
                                                            onChange: function(e) {
                                                                return setCategory(e.target.value);
                                                            },
                                                            value: category,
                                                            className: "block w-full px-6 py-3 text-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-green focus:border-green sm:text-sm",
                                                            children: filters[0].map(function(category, index) {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                    children: category
                                                                }, index);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex flex-col items-center justify-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        type: "submit",
                                                        className: "inline-flex items-center px-6 py-3 text-lg font-medium text-white border border-transparent shadow-sm bg-green hover:bg-darkGreen focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green",
                                                        onClick: handleSearch,
                                                        children: "Search"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "pt-4 lg:grid lg:grid-cols-2 lg:gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mb-10 lg:col-span-1 md:mb-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                className: "py-12 pb-0 text-4xl tracking-tight sm:text-3xl lg:text-4xl text-green",
                                                children: [
                                                    "Texas Forms - ",
                                                    category,
                                                    " - ",
                                                    year
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "lg:col-span-1",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex items-center justify-center h-full",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flow-root min-w-full mt-6",
                                                    children: [
                                                        currentFormList && currentFormList.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                role: "list",
                                                                className: "pb-4 divide-y divide-lightGrey md:w-full",
                                                                children: currentFormList.map(function(file, index) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        className: "py-4",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "flex items-center space-x-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: "flex-1 min-w-0",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                        className: "text-xl text-grey",
                                                                                        children: file.name
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                        href: "https://api.evryhealth.com/api/v1/Marketing/GetFileContent?id=".concat(file.file_id),
                                                                                        className: "inline-flex items-center px-2.5 py-0.5",
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                            className: "h-8",
                                                                                            src: "download-icon.svg",
                                                                                            alt: "Download form"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, index);
                                                                })
                                                            })
                                                        }) : !loading && !error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-2xl md:text-4xl",
                                                                children: "No forms found for the selected filters."
                                                            })
                                                        }),
                                                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-2xl md:text-4xl",
                                                                children: "Loading..."
                                                            })
                                                        }),
                                                        error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-center",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-2xl md:text-4xl",
                                                                children: "Something went wrong. Please try again later."
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FormsAndPolicies);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,875,774,888,179], function() { return __webpack_exec__(478); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);